/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.REACT_APP_SITECORE_API_KEY || "SS9Ub2xjWGxYWWJ2WC9YOVFrVVRsaWdUVFV5a2FjRDBpaWFFN0twL28vWT18ZGF5Y29ldXJvcGVzcmwtZ2xvYmFsYWZ0ZXI3ZDcxLXVhdC01MGI0",
config.sitecoreApiHost = process.env.REACT_APP_SITECORE_API_HOST || "https://edge.sitecorecloud.io",
config.jssAppName = process.env.REACT_APP_JSS_APP_NAME || "dayco",
config.defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
config.graphQLEndpointPath = process.env.REACT_APP_GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge",
config.graphQLEndpoint = process.env.REACT_APP_GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports = config;